<template>
    <v-row class="pb-md-2">
        <v-row>
            <v-col
                md="3"
            >
                <v-img
                    contain
                    height="300px"
                    width="450px"
                    :src="selectedDevice && selectedDevice.devices[selectedVersionIndex] ? selectedDevice.devices[selectedVersionIndex].images[0].url : ''"
                ></v-img>
            </v-col>
            <v-col
                md="9"
                class="pt-md-11"
            >
                <h4 class="font-weight-normal pl-md-6 pb-md-2">Colores Disponibles</h4>
                <v-btn-toggle
                    class="pb-md- py-md-1 pl-md-5 no-background"
                    mandatory
                    v-model="selectedVersionIndex"
                >
                    <v-btn
                        v-for="device in selectedDevice.devices"
                        :key="device.id"
                        class="btn-round mx-1"
                        :color="device.color"
                        fab
                        x-small
                        elevation="2"
                    ></v-btn>
                </v-btn-toggle>
                <h4 class="pt-md-5 pb-md-3 font-weight-normal pl-md-6">Descripción</h4>
                <p class="font-weight-light text-justify px-md-6 pb-md-6">{{selectedDevice ? selectedDevice.description : ''}}</p>
            </v-col>
        </v-row>
    </v-row>
</template>

<script>
    import { mapState } from 'vuex'

    export default{
        name:'DevicePreview',
        data : ()=>({
            colors: [],
            selectedColor: null,
            selectedVersionIndex: 0,
        }),
        methods:{
            clearFields(){
                this.colors = [],
                this.selectedColor = null
                this.selectedVersionIndex = 0
            }
        },
        computed:{
            ...mapState("deviceManagement", {
                selectedDevice: state => state.selectedDevice,
            })
        },
        watch: {
            selectedDevice(){
                this.clearFields()
            }
        }
    }
</script>

<style>
.btn-round {
    border-radius: 30px !important;
}
.no-background {
    background: none !important;
}
</style>